export default {
  TRANSACTIONS_LIST: "Liste des transactions",
  VIEW_TRANSACTION: "Voir la transaction",
  RESYNC_THIS_TRANSACTION: "Resynchroniser cette transaction",
  DELETE_THIS_TRANSACTION: "Supprimer cette transaction",
  RESYNC_CONFIRMATION: "Confirmer la resynchronisation",
  DELETE_CONFIRMATION: "Confirmer la suppression",
  TRANSACTION_RESYNCED: "Transaction resynchronisée",
  TRANSACTION_DELETED: "Transaction supprimée",
  GENERAL_INFO: "Informations générales",
  TRANSACTION_ID: "ID de la transaction",
  TRANSACTION_STATUS: "Statut de la transaction",
  TRANSACTION_AMOUNT: "Montant de la transaction",
  TRANSACTION_DATE: "Date de la transaction",
  TRANSACTION_TYPE: "Type de la transaction",
  TRANSACTION_CUSTOMER: "Client de la transaction",
  TRANSACTION_ORGANIZATION: "Organisation de la transaction",
  TRANSACTION_PAYMENT_METHOD: "Moyen de paiement de la transaction",
  TRANSACTION_PAYMENT_STATUS: "Statut de paiement de la transaction",
  AMOUNT: "Montant",
  STATUS: "Statut",
  PAYMENT_METHOD: "Moyen de paiement",
  RELATED_INFO: "Informations liées",
  PAYABLE_TYPE: "Type de paiement",
  PAYABLE_DETAILS: "Détails du paiement",
  PAYMENT_INFORMATION: "Informations de paiement",
  INVOICE_CODE: "Code de facture",
  INVOICE_CODE_PLACEHOLDER: "Code de facture",
  METHOD_CB: "CB",
  METHOD_TFE: "TFE",
  INITIATE_PAYMENT: "Initier le paiement",
  PAYMENT_IFRAME_INFO: "Informations de paiement",
  CHECK_STATUS: "Vérifier le statut",
  PAYMENT_SUMMARY: "Résumé du paiement",
  NEW_PAYMENT: "Nouveau paiement",
  TRANSACTION_CODE: "Code de transaction",
  ELIXIOPAY_ID: "ID ElixioPay",
  PAYMENT_INITIATED: "Paiement initié",
  STATUS_PENDING: "En attente",
  STATUS_AUTHORIZED: "Autorisé",
  STATUS_CAPTURED: "Capturé",
  STATUS_FAILED: "Échoué",
  STATUS_DECLINED: "Refusé",
  STATUS_EXPIRED: "Expiré",
  STATUS_CANCELLED: "Annulé",
  STATUS_REFUNDED: "Remboursé",
  STATUS_PARTIALLY_REFUNDED: "Partiellement remboursé",
  STATUS_ERROR: "Erreur",
  STATUS_PAID: "Payé",
  STATUS_DRAFT: "Brouillon",
  START_DATE: "Date de début",
  END_DATE: "Date de fin",
  SEARCH: "Rechercher",
  ID: "ID",
  RESYNC: "Resynchroniser",
  DELETE: "Supprimer",
  TRANSACTION_INFO: "Informations de la transaction",
  PROVIDER: "Fournisseur",
  PROVIDER_TRANSACTION_ID: "ID de la transaction du fournisseur",
  PAYABLE: "Paiement",
  PAYABLE_DETAILS: "Détails du paiement",
  SERVICE: "Service",
  METADATA: "Metadata",
};
